import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/payment';

class PaymentService {
  createPaymentsForClient = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/installments/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data, message, paidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount } = response.data;

      return { data, message, paidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating payments for client.');
    }
  };

  acceptPaymentForClient = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/accept`, body);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message, paymentId: body.paymentId, notificationId: body.notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while accepting payments for client.');
    }
  };

  rejectPaymentForClient = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/reject`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;
      return { data, message, paymentId: body.paymentId, notificationId: body.notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while rejecting payments for client.');
    }
  };

  getClientPayment = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount, message } = response.data;
      return { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching payments for client.');
    }
  };

  createClientPayment = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating payment  client.');
    }
  };

  getClientPaymentPlan = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}/plan`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, totalAmount, deposit, message } = response.data;
      return { data, totalAmount, deposit, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching payment plan for client.');
    }
  };

  editPaymentPlanForClient = async (id, body) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/installments/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount, message } = response.data;
      return { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating payments for client.');
    }
  };

  deleteClientPayment = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/client/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;
      return { data, id, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting client payment.');
    }
  };
}
const paymentService = new PaymentService();

export default paymentService;
